export const countryListTableConfig = [
  {
    field: 'mappingId',
    header: 'Mapping ID',
    filter: false,
    visible: true,
    defaultPinned: true,
    sortable: false,
    order: 1,
    menuItems: [],
  },
  {
    field: 'countryName',
    header: 'Country Name',
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 2,
    menuItems: [],
    pinnable: false,
  },
  {
    field: 'regionName',
    header: 'Region Name',
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 3,
    menuItems: [],
    pinnable: false,
  },
  {
    field: 'status',
    header: 'Is Active',
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 4,
    menuItems: [],
    pinnable: false,
  },
  {
    field: 'action',
    header: 'Action',
    className: 'country-list-action-column',
    headerClassName: 'country-list-action-column',
    width: 180,
    exportable: false,
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 5,
    menuItems: [],
    pinnable: false,
  },
];
